export function newsStateReducer(
  state = { posts: [], loading: true, error: false },
  action
) {
  switch (action.type) {
    case "GET_NEWS_POSTS_START":
      return {
        ...state,
        loading: true
      };
    case "GET_NEWS_POSTS_ERROR":
      return {
        ...state,
        loading: false,
        error: true
      };
    case "GET_NEWS_POSTS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        posts: action.payload
      };
    default:
      return state;
  }
}
